import React, { useEffect, useState } from 'react';

// Красный баннер аварийного режима «Продажи без оприходования» (unreceived_sales.md v3).
// Виден на всех страницах, пока режим включён (флаг в /api/health).
// Координация с жёлтой плашкой тест-контура (ContourBanner): при contour==='test'
// сдвигаемся ниже неё (top 26px) и добавляем body paddingTop до 52px.
const BANNER_HEIGHT = 26;

const UnreceivedModeBanner: React.FC = () => {
  const [active, setActive] = useState(false);
  const [isTest, setIsTest] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch('/api/health')
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (cancelled || !data) return;
        setActive(data.unreceived_sales_mode === true);
        setIsTest(data.contour === 'test');
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!active) return undefined;
    const total = BANNER_HEIGHT + (isTest ? BANNER_HEIGHT : 0);
    const prevPadding = document.body.style.paddingTop;
    document.body.style.paddingTop = `${total}px`;
    return () => {
      document.body.style.paddingTop = prevPadding;
    };
  }, [active, isTest]);

  if (!active) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: isTest ? BANNER_HEIGHT : 0,
        left: 0,
        right: 0,
        height: BANNER_HEIGHT,
        zIndex: 999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#cf1322',
        color: '#fff',
        fontWeight: 700,
        fontSize: 13,
        letterSpacing: 0.5,
        userSelect: 'none',
      }}
    >
      АВАРИЙНЫЙ РЕЖИМ: продажи без оприходования (сбой ЭДО)
    </div>
  );
};

export default UnreceivedModeBanner;
